/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RewardStatusBundle {
    AVAILABLE = 'Available',
    OUT_OF_STOCK = 'OutOfStock',
    EXPIRED = 'Expired',
}
